@if ({
  attributes: attributes$ | async
  }; as vm) {
  <div
    id="attribute-selectors-container"
    class="hmf-mb-m">
    @for (attributeGroup of vm.attributes; track trackByFn($index, attributeGroup); let isLast = $last) {
      <div [ngClass]="!isLast ? 'hmf-mb-xs hmf-mb-md-s' : ''">
        @if ((selectErrorList$ | async); as errors) {
          @if (errors[attributeGroup[0]?.name]) {
            <div
              class="hmf-mb-xs">
              <span class="hmf-display-flex label-negative hmf-header-bold-xs hmf-text-transform-none">
                <homefield-icon
                  class="error-msg-icon"
                  width="24px"
                  height="14px"
                  fill="var(--hmf-label-negative)"
                name="alert-info-filled"></homefield-icon>
                {{ errors[attributeGroup[0]?.name] }}
              </span>
            </div>
          }
        }
        <hmf-selector
          [id]="attributeGroup[0]?.name.toLowerCase() + '-panel-button'"
          [contained]="true"
          [selector]="'rectangular'"
          [width]="'100%'"
          [ariaLabel]="'Open ' + attributeGroup[0]?.name.toLowerCase() + ' panel'"
          (keydown.enter)="openDrawer()"
          (keydown.space)="openDrawer()"
          (click)="openDrawer()">
          <div
            ngProjectAs="rectangularSelectorBody"
            class="hmf-display-flex hmf-align-items-center hmf-justify-content-between">
            <div
              class="attribute-display-value hmf-m-s hmf-display-flex hmf-align-items-center">
              @if (
                clubAttributeMap &&
                (clubAttributeMap[attributeGroup[0]?.name.toLowerCase()]
                | async); as selectedValue) {
                <span class="hmf-header-xs hmf-mr-xxxs label-base">{{
                  attributeGroup[0]?.name
                }}</span>
                <span class="hmf-header-bold-xs label-base">
                  {{ selectedValue.value }}</span
                  >
                } @else {
                  <span class="hmf-header-bold-xs hmf-mr-xxxs label-base"
                    >Select {{ attributeGroup[0]?.name }}</span
                    >
                  }
                </div>
                <div class="hmf-display-flex hmf-align-items-center">
                  <homefield-icon
                    width="22px"
                    height="22px"
                    alt="arrow right"
                    name="chevron-right"
                    class="hmf-mr-xxs">
                  </homefield-icon>
                </div>
              </div>
            </hmf-selector>
          </div>
        }
      </div>
      @if (customSeoUrl) {
        <div id="customize-button">
          <p class="hmf-subheader-l hmf-text-align-center label-base-subtle">Need More Options?</p>
          <hmf-selector
            id="customize-button"
            [contained]="true"
            [selector]="'rectangular'"
            [width]="'100%'"
            [ariaLabel]="'Customize Your Own'"
            (keydown.space)="registerAnalyticsAndRedirect()"
            (keydown.enter)="registerAnalyticsAndRedirect()"
            (click)="registerAnalyticsAndRedirect()">
            <div
              ngProjectAs="rectangularSelectorBody"
              class="hmf-display-flex hmf-align-items-center">
              <div class="size-display-value hmf-m-s hmf-display-flex hmf-align-items-center">
                <div class="gradient-box hmf-position-relative hmf-mr-s">
                  <homefield-icon
                    width="14px"
                    height="14px"
                    alt="customize"
                    name="pen-edit"
                  class="hmf-mr-xxs"></homefield-icon>
                </div>
                <span class="hmf-header-bold-xs hmf-mr-xxxs label-base"
                  >Customize Your Own
                </span>
              </div>
            </div>
          </hmf-selector>
        </div>
      }
      <hmf-drawer
        id="attribute-config-panel"
        [direction]="drawerDirection()"
        [interactability]="false">
        <div class="hmf-display-flex hmf-flex-column selection-panel-content-wrapper">
          <div class="hmf-px-s">
            <h2 class="hmf-header-bold-s hmf-p-m hmf-text-align-center">Choose Configurations</h2>
          </div>
          <div class="hmf-px-s hmf-pb-s overflow-auto">
            <pdp-price
              class="hmf-mb-xs hmf-display-block">
            </pdp-price>
            @for (attributeGroup of vm.attributes; track trackByFn($index, attributeGroup); let isLast = $last) {
              <pdp-attributes-components-default-attribute-selection
                [isConfigVariant]="true"
                [labelAttrGroupName]="attributeGroup[0].name"
                [selectorAttributeData]="attributeGroup"
                [alternativeInStockIsShowing]="false"
                [overflowXScroll]="false"
                (selectedAttributeOnClick)="markSelectedAttributes($event)">
              </pdp-attributes-components-default-attribute-selection>
            }
            <div
              class="button-container hmf-display-flex hmf-justify-content-between hmf-mt-l hmf-mt-md-xl">
              <div class="hmf-mr-s">
                <hmf-button
                  tabindex="0"
                  text="Save"
                  label="close attribute selection drawer"
                  [variant]="'secondary'"
                  [loading]="false"
                  [disabled]="false"
                  [size]="'medium'"
                  (click)="closeDrawer()">
                </hmf-button>
              </div>
              <div class="hmf-flex-grow">
                <pdp-feature-add-to-cart-button
                  class="hmf-display-flex hmf-flex-column hmf-h-100"
                  [ecode]="product.partNumber"
                  [showQuantityInput]="false"
                  [disabled]="(resolvedSku$ | async) === null">
                </pdp-feature-add-to-cart-button>
              </div>
            </div>
          </div>
        </div>
      </hmf-drawer>
    }
